<template>
  <div class="table-action-wrapper">
    <input type="date" class="form-control has-tip" data-title="Start Date" :value="query.date_start.value" @change="changeDateStart" />
    <input type="date" class="form-control has-tip" data-title="End Date" :value="query.date_end.value" @change="changeDateEnd" />
    <Select source="sale-account/search" placeholder="Account Name" data-title="Account Name" class="has-tip" v-model="query.account_id"></Select>
    <Select source="user/search" type="auto" field="sale-account.user" placeholder="Seller" data-title="Seller" class="has-tip" v-model="query.user_ids"></Select>
    <Select :options="loggedOptions" placeholder="Login Status" data-title="Login Status" class="has-tip" v-model="query.logged"></Select>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      query: {
        date_start: moment().format('Y-MM-DD'),
        date_end: moment().format('Y-MM-DD'),
        account_id: '',
        user_ids: '',
        logged: ''
      }
    }
  },
  created() {
    let query = Object.assign({}, this.query, this.$route.query)
    if (JSON.stringify(query) != JSON.stringify(this.query)) {
      this.query = query
      this.submit()
    }
  },
  computed: {
    extraAttributes() {
      return Object.assign(
        {
          logged: []
        },
        this.config?.extraAttributes || {}
      )
    },
    loggedOptions() {
      return this.extraAttributes?.logged
    }
  },
  props: {
    config: Object
  },
  methods: {
    changeDateStart(e) {
      this.query.date_start = Object.assign(this.query.date_start, {
        value: e.currentTarget.value,
        valueLabel: e.currentTarget.value
      })
      this.$emit('change-filters', this.query)
    },
    changeDateEnd(e) {
      this.query.date_end = Object.assign(this.query.date_end, {
        value: e.currentTarget.value,
        valueLabel: e.currentTarget.value
      })
      this.$emit('change-filters', this.query)
    },
    submit() {
      this.$emit('change-filters', this.query)
    }
  }
}
</script>
